<div class="app-header" *ngIf="userService.currentUser">

	<div class="logo-wrapper">

		<div class="header-dropdown" ngbDropdown container="body" (openChange)="showSwitch = !showSwitch">
			<button class="btn toggle-btn" ngbDropdownToggle>
				<i class="fas fa-th"></i>
			</button>

			<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
				<evo-switch *ngIf="switchProductsOrganizations && showSwitch"
				            (switchOrganizations)="goToOrganizationList()"
				            [switchProductsOrganizations]="switchProductsOrganizations"
				            [showAdmin]="false">
				</evo-switch>
			</div>
		</div>


		<div class="product-logo ADMIN"></div>

		<h5>Administrador</h5>
	</div>

	<div class="main-menu" *ngIf="organizationService.currentOrganization.id && organizationService.currentOrganization.name">
		<span>{{ organizationService.currentOrganization.name }}</span>

		<button routerLink="/organizations/{{organizationService.currentOrganization.id}}" routerLinkActive="active" *ngxPermissionsOnly="adminPermissionsArr">
			Detalhes
		</button>
		<button routerLink="/users" routerLinkActive="active"
		        *ngxPermissionsOnly="[adminPermissions.VIEW_USERS, adminPermissions.INVITE_USER_ORGANIZATION, adminPermissions.REMOVE_USER_ORGANIZATION, adminPermissions.MANAGE_USERS_INVITATION, adminPermissions.ALL_PERMISSIONS]">Usuários
		</button>
		<button routerLink="/roles" routerLinkActive="active"
		        *ngxPermissionsOnly="[adminPermissions.VIEW_ROLES, adminPermissions.EDIT_ROLES, adminPermissions.CREATE_ROLES, adminPermissions.EDIT_USERS_ROLES, adminPermissions.ALL_PERMISSIONS]">Perfis
		</button>
		<button routerLink="/positions" routerLinkActive="active"
		        *ngxPermissionsOnly="[adminPermissions.CREATE_POSITION, adminPermissions.EDIT_POSITION, adminPermissions.DELETE_POSITION, adminPermissions.ALL_PERMISSIONS]">Cargos
		</button>
	</div>

	<div class="action-wrapper">
		<div class="action-buttons">
			<!-- <button class="btn">
				<i class="fas fa-bell"></i>
			</button>
			<button class="btn">
				<i class="fas fa-question-circle"></i>
			</button> -->

			<button class="btn toggle-btn" (click)="toggleTheme()" 
				[title]="(themeService.getTheme$() | async) === 'light' ? 'Alternar para tema escuro' : 'Alternar para tema claro'">
				<i class="fas" [class.fa-moon]="(themeService.getTheme$() | async) === 'light'" 
				               [class.fa-sun]="(themeService.getTheme$() | async) === 'dark'"></i>
			</button>

			<button class="btn toggle-btn" *ngIf="showSupport" (click)="openHelpDialog()" [title]="'Ajuda e Suporte'">
				<svg xmlns="http://www.w3.org/2000/svg"
				  viewBox="-1 1 24 24"
				  width="38"
				  height="38"
				  fill="currentColor">
				<g transform="scale(0.045) translate(12,12)">
				<path d="M320 352h-4.7c-12.16 0-24 2.9-35.5 6.8a173.76 173.76 0 0 1-111.64 0c-11.48-3.9-23.29-6.78-35.42-6.78H128A128 128 0 0 0 0 480a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32 128 128 0 0 0-128-128zM32 480a96.1 96.1 0 0 1 96-96h4.74c6.92 0 14.92 1.62 25.16 5.09a205.75 205.75 0 0 0 132.16 0c10.31-3.49 18.33-5.11 25.24-5.11h4.7a96.1 96.1 0 0 1 96 96zm16-256a16 16 0 0 0 16-16v-16c0-88.22 71.78-160 160-160s160 71.78 160 160v16a80.09 80.09 0 0 1-80 80h-32a32 32 0 0 0-32-32h-32a32 32 0 0 0 0 64h96a112.14 112.14 0 0 0 112-112v-16C416 86.12 329.88 0 224 0S32 86.12 32 192v16a16 16 0 0 0 16 16zM224 96a95.57 95.57 0 0 1 71.23 159.76c0 .09.13.15.18.24H304a47.89 47.89 0 0 0 40.55-22.58C349 220.36 352 206.58 352 192a128 128 0 0 0-256 0c0 40.42 19.1 76 48.35 99.47-.06-1.17-.35-2.28-.35-3.47a63.25 63.25 0 0 1 8.93-32A95.58 95.58 0 0 1 224 96z"
				  stroke="currentColor"
				  stroke-width="8"
				  stroke-linejoin="round"/>
				</g>
				</svg>
			  </button>

			<a href="https://evollo.com.br/artigos" target="_blank" class="btn toggle-btn" *ngIf="showFaq">
				<i class="far fa-question-circle"></i>
			</a>

			<!-- <button class="btn" (click)="goToOrganizationList()">
				<i class="fas fa-cog"></i>
			</button> -->
		</div>

		<span class="user-info">
			{{ userService.currentUser.name }}
		</span>

		<div class="header-dropdown" ngbDropdown container="body">
			<avatar-initials style="cursor: pointer;" [small]="true" [initialsColor]="'#fff'" [name]="userService.currentUser.name" ngbDropdownToggle></avatar-initials>

			<!-- <button class="btn pl-2" data-no-icon="true" ngbDropdownToggle>
				<i class="fas fa-ellipsis-h"></i>
			</button> -->
			<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right py-2" role="menu">
				<a class="dropdown-item pointer" [href]="idUrl">
					<i class="far fa-user"></i>
					<span class="">Configuração da conta</span>
				</a>

				<hr class="my-1"/>

				<a class="dropdown-item pointer" (click)="logout()">
					<svg
					  xmlns="http://www.w3.org/2000/svg"
					  width="18"
					  height="18"
					  viewBox="0 0 512.009 384"
					  fill="currentColor"
					  class="mr-2">
					  <g transform="translate(0 -64)">
						<path
						  d="M180,448H96A96,96,0,0,1,0,352V160A96,96,0,0,1,96,64h84a12,12,0,0,1,12,12v40a12,12,0,0,1-12,12H96a32,32,0,0,0-32,32V352a32,32,0,0,0,32,32h84a12,12,0,0,1,12,12v40a12,12,0,0,1-12,12Z"
						  opacity="0.4" />
						<path
						  d="M353,88.3,504.9,238.9a24,24,0,0,1,0,34.1l-152,150.8a24.08,24.08,0,0,1-33.9-.1l-21.9-21.9a24.07,24.07,0,0,1,.8-34.7L375.5,296H184a23.94,23.94,0,0,1-24-24V240a23.94,23.94,0,0,1,24-24H375.5l-77.6-71.1a24,24,0,0,1-.7-34.6l21.9-21.9a24,24,0,0,1,33.9-.1Z" />
					  </g>
					</svg>
					Sair
				  </a>
			</div>
		</div>
	</div>

</div>
